export default __webpack_public_path__ + "static/media/img-store-coffee-beans.645c6f62.png";